<div
  class="onboarding-item"
  [class.onboarding-item-completed]="item.completed"
  [class.pointer-events]="!item.enabled"
  [class.onboarding-item-disabled]="!item.enabled"
  fxLayout
  fxLayoutAlign="space-between center"
  fxLayoutGap="18px"
  fxLayoutGap.lt-md="8px">
  <div fxFlex="24px">
    <div
      *ngIf="!item.completed"
      (click)="item.can_manually_mark_as_completed ? markItemAsCompleted(item, parentId, true) : null">
      <img
        [class.onboarding-unchecked]="item.can_manually_mark_as_completed"
        src="/assets/images/onboarding/check-unchecked.svg"
        alt="Not completed"
        onload="SVGInject(this)" />
    </div>
    <div
      *ngIf="item.completed"
      [class.clickable]="item.completion_source === 'user'"
      (click)="item.completion_source === 'user' ? markItemAsCompleted(item, parentId, false) : null">
      <img
        class="onboarding-checked"
        src="/assets/images/onboarding/check.svg"
        alt="Completed"
        onload="SVGInject(this)" />
    </div>
  </div>

  <span fxFlex class="strong night">{{ item.title }}</span>

  <!-- Item has an action -->
  <sbnb-button
    *ngIf="item.action?.label && !item.completed"
    type="primary-teal"
    size="mini"
    [label]="item.action.label"
    (click)="
      item.action.link ? openActionLink(item.action.link) : item.action.tour_id ? openTour(item.action) : null
    "></sbnb-button>

  <!-- Item completed, and has no children -->
  <span *ngIf="item.completed && item.children?.length === 0" class="grass-darker text__small" fxFlex="0 0 auto">
    <span *ngIf="item.completion_source === 'system'" fxHide.lt-md>🎉 You’ve completed this.</span>
    <span *ngIf="item.completion_source === 'user'" fxHide.lt-md>🎉 You’ve checked this item.</span>
    <span
      class="strong clickable"
      (click)="
        item.action.link ? openActionLink(item.action.link) : item.action.tour_id ? openTour(item.action) : null
      ">
      Show again
    </span>
  </span>

  <!-- Item has children -->
  <div
    *ngIf="item.children?.length > 0"
    class="onboarding-children-label clickable"
    [class.onboarding-dropdown-rotate]="!item.children_expanded"
    fxLayout
    fxLayoutAlign="start center"
    fxLayoutGap="20px"
    (click)="expandCollapseChildren(item)">
    <span class="grass-darker">{{ item.children | countCompletedOnboarding }}/{{ item.children.length }}</span>
    <img
      class="onboarding-dropdown"
      src="/assets/images/onboarding/dropdown.svg"
      alt="Show children"
      onload="SVGInject(this)" />
  </div>
</div>

<div *ngIf="item.children?.length > 0" [hidden]="!item.children_expanded" class="onboarding-children-container">
  <sbnb-onboarding-item
    *ngFor="let child of item.children; trackBy: trackById"
    [item]="child"
    [parentId]="item.id"></sbnb-onboarding-item>
</div>
